package com.tovtalk.presentation.state

/**
 * UI State - מצב ממשק משתמש
 */
sealed class UiState<out T> {
    data object Idle : UiState<Nothing>()
    data object Loading : UiState<Nothing>()
    data class Success<T>(val data: T) : UiState<T>()
    data class Error(val message: String) : UiState<Nothing>()
    /** Post/reel blocked by viewer kashrut level; show message + link to settings */
    data class KashrutBlocked(val message: String) : UiState<Nothing>()
    
    val isLoading: Boolean get() = this is Loading
    val isSuccess: Boolean get() = this is Success
    val isError: Boolean get() = this is Error
    val isIdle: Boolean get() = this is Idle
    val isKashrutBlocked: Boolean get() = this is KashrutBlocked
    
    fun getDataOrNull(): T? = when (this) {
        is Success -> data
        else -> null
    }
}

/**
 * Paging State - מצב דפדוף
 */
data class PagingState<T>(
    val items: List<T> = emptyList(),
    val cursor: String? = null,
    val isLoading: Boolean = false,
    val isLoadingMore: Boolean = false,
    val hasMore: Boolean = true,
    val error: String? = null,
    val kashrutRestricted: Boolean = false
)
